import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function OpeningHookSection() {
  return <SectionWrapper altBg narrow data-id="element-85">
      <div className="space-y-8 text-lg md:text-xl text-secondary leading-relaxed font-body" data-id="element-86">
        <p className="first-letter:text-5xl first-letter:font-heading first-letter:text-primary first-letter:mr-2 first-letter:float-left" data-id="element-87">
          Entras a su cuarto y antes de que puedas decir "hola", ya sientes la
          tensión. Haces una pregunta simple y recibes un suspiro de fastidio,
          una respuesta cortante o, peor aún, el silencio absoluto seguido de un
          portazo.
        </p>

        <p data-id="element-88">
          Cenas en una mesa donde el ruido de los cubiertos duele más que las
          palabras que no se dicen. Sientes que caminas sobre cáscaras de huevo
          en tu propia casa, con el miedo constante de que cualquier comentario
          desate una guerra civil.
        </p>
      </div>
    </SectionWrapper>;
}